import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default () => {
    const page = usePage<IRhizomPageProps>();

    const showPastDueWarning = computed(
        () =>
            page.props.isCurrentSubscriptionPastDue === true &&
            page.props.isSubscribed === true,
    );

    return {
        showPastDueWarning,
    };
};
